import React, { useEffect, useState } from "react";
import { useGetList } from "../../../../hooks/useGetList";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedBranch } from "../../../../redux/itemUnit/filterUnitSlice";

const ProductItemUnitHeader = () => {
  const { data: branchData, loading: branchLoading } =
    useGetList(`branch/options`);

  const { selectedBranch } = useSelector((state) => state.filterItemUnit);

  const dispatch = useDispatch();

  const handleBranch = (e) => {
    dispatch(setSelectedBranch(e.target.value));
  };

  useEffect(() => {
    if (branchData?.data) {
      dispatch(setSelectedBranch(branchData?.data[0]?._id));
    }
  }, [branchData]);

  return (
    <div>
      <FormControl fullWidth style={{ maxWidth: 250, marginBottom: 20 }}>
        <InputLabel id="branch-select-label">Branch</InputLabel>
        <Select
          labelId="branch-select-label"
          id="branch-select"
          value={selectedBranch}
          label="Branch"
          onChange={handleBranch}
          disabled={branchLoading}
        >
          {branchData?.data?.map((branch) => (
            <MenuItem key={branch._id} value={branch._id}>
              {branch.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default ProductItemUnitHeader;
